import React, { useEffect, useState } from "react";
import "./membership.css";
import { ScrollToTop, Modal } from "../../components";
import { membershipContent } from "../../constants/data";
import { HashLink as Link } from "react-router-hash-link";
import MembershipSkeleton from "../../components/skeletons/MembershipSkeleton";
import ProgressiveImage from "../../components/ProgressiveImage";
import MembershipPageMetadata from "../../components/generateMetadata/membershipPageMetadata";

const Membership = () => {
  const [openModal, setOpenModal] = useState(false);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate data fetching
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (loading) {
    return <MembershipSkeleton />;
  }
  return (
    <>
      <MembershipPageMetadata />
      <section className="membershipHeader">
        <div className="container">
          <div className="heroContent">
            <div className="txtContent">
              <h3>{membershipContent.heroText}</h3>
            </div>
          </div>
        </div>
      </section>
      <section className="family">
        <div className="container">
          <div className="hor">
            <div className="ver">
              <div className="content">
                <div className="header">
                  <h1>{membershipContent.familySection.header}</h1>
                </div>
                <div className="txtContent">
                  <article>
                    <h3>{membershipContent.familySection.subTitle}</h3>
                    <p>{membershipContent.familySection.textContent}</p>
                  </article>
                </div>
                <div className="btnHolder">
                  <Link
                    to={"https://form.jotform.com/211587666897275"}
                    className="btnPrimary"
                    target="_blank"
                  >
                    become a member
                  </Link>
                </div>
              </div>
            </div>
            <div className="ver">
              <div className="imgWrapper">
                <ProgressiveImage
                  lowQualitySrc={
                    membershipContent.familySection.lowQualityImage
                  }
                  highQualitySrc={membershipContent.familySection.image}
                  alt={membershipContent.familySection.header}
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="volunteer">
        <div className="container">
          <div className="hor">
            <div className="ver">
              <div className="imgWrapper">
                <ProgressiveImage
                  lowQualitySrc={
                    membershipContent.volunteerSection.lowQualityImage
                  }
                  highQualitySrc={membershipContent.volunteerSection.image}
                  alt={membershipContent.volunteerSection.header}
                />
              </div>
            </div>
            <div className="ver">
              <div className="content">
                <div className="header">
                  <h1>{membershipContent.volunteerSection.header}</h1>
                </div>
                <div className="txtContent">
                  <article>
                    <h3>{membershipContent.volunteerSection.subTitle}</h3>
                    <p>{membershipContent.volunteerSection.textContent}</p>
                  </article>
                </div>
                <div className="btnHolder">
                  <a onClick={() => setOpenModal(true)} className="btnPrimary">
                    become a volunteer
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {openModal && <Modal closeModal={setOpenModal} />}
      <ScrollToTop />
    </>
  );
};

export default Membership;
